<template>
    <div class="flex flex-col md:flex-row gap-4 flex-wrap">
        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/common/beaker.png" alt="Beaker icon" />

            <h5 class="text-2xl text-darkerblue text-center">Blood work</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>Hemoglobin of 9.1 g/dL with MCV of 87 fL and MCHC of 31 g/dL</li>
                <li>Total leukocyte count was 6300/μL, and platelet count was 170,000/μL</li>
                <li>Direct Coombs test was negative</li>
                <li>The peripheral blood film was negative for schistocytes</li>
            </ul>
        </div>

        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-maroon bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/common/serology.svg" alt="Beaker icon" />

            <h5 class="text-2xl text-darkerblue text-center">Serologies</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>Complement levels were within the normal ranges</li>
                <li>Tests for ANA, anti-MPO, anti-PR3, and anti-GBM antibodies were negative</li>
            </ul>
        </div>

        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-purple bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/postpartum/Liver-purple.svg" alt="Liver icon" class="mt-3" />

            <h5 class="text-2xl text-darkerblue text-center mt-2">Liver Tests</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>
                    AST levels were 17 IU/L
                </li>
                <li>
                    ALT levels were 13 IU/L
                </li>
                <li>
                    Bilirubin was 0.8 mg/dL
                </li>
            </ul>
        </div>

        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-darkerblue bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/kidneys.svg" alt="Kidneys icon" />

            <h5 class="text-2xl text-darkerblue text-center">Urinalysis, urine cultures, and blood cultures</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>No hydronephrosis</li>
                <li>Kidney arterial and venous Doppler ultrasound scans were normal</li>
            </ul>

        </div>
    </div>
</template>
